/**
 * Combines multiple loading statuses into a single status.
 *
 * @param statuses An array of loading statuses, or multiple loading statuses passed as separate arguments.
 * @returns The single loading status.
 */
export const combineStatuses = (...statuses) => {
    const statusesArray = statuses.flat();
    if (statusesArray.includes("error")) {
        return "error";
    }
    else if (statuses.every((s) => s === "loaded")) {
        return "loaded";
    }
    else if (statuses.every((s) => s === "init")) {
        return "init";
    }
    else if (statusesArray.includes("waiting")) {
        return "waiting";
    }
    else if (statusesArray.includes("progress")) {
        return "progress";
    }
    else if (statusesArray.includes("loading")) {
        return "loading";
    }
    else if (statusesArray.every((s) => s === "init" || s === "loaded")) {
        return "loaded";
    }
    return "init";
};
